import imageOne from './img/car1.jpeg';
import imageTwo from './img/car2.jpeg';
import imageThree from './img/car3.jpeg';


export const imageData = [
    {
        image:imageOne
    },
    {
        image:imageTwo
    },
    {
        image:imageThree
    }
]
